import { render } from "./test-page.vue?vue&type=template&id=362364d2"
import script from "./test-page.vue?vue&type=script&lang=js"
export * from "./test-page.vue?vue&type=script&lang=js"
script.render = render

export default script